import { Injectable } from '@angular/core';

import { BaseEditCreateService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCreateService<T, TEdit> extends BaseEditCreateService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
